import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

export const FormatPrice = ({ quantity, unit, price }) => (
  `${quantity} ${unit} ${formatPriceToBRL(price)}`
)

export const PrefixPrice = ({ packaging, packagingCount }) => {
  const isDecimal = packaging => packaging % 1 !== 0
  const plural = packagingCount === 1 ? 'caixa' : 'caixas'
  return isDecimal(packaging) ? `${packagingCount} ${plural} | ` : ''
}
